<template>
  <div>
    <label class="tla-form-group__label tla-form-group__label--required">Current Vehicle Information <span>*</span></label>

    <div class="tla-vehicle-result">
      <div class="tla-vehicle-result__result">
          <div class="tla-vehicle-result__item">
              <div class="tla-vehicle-result__label">{{vehicleNameLabel}}</div>
              <div class="tla-vehicle-result__description">{{vehicleName}}</div>
          </div>
          <div class="tla-vehicle-result__item">
              <div class="tla-vehicle-result__label">Plate Year</div>
              <div class="tla-vehicle-result__description">{{vehiclePlate}}</div>
          </div>
          <div class="tla-vehicle-result__edit-icon" :class="{'tla-vehicle-result__edit-icon--disabled': showDisabledState}" @click="clicked()">
          </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  Component, Prop, Vue, Watch, Inject
} from 'vue-property-decorator';
import Valuation from '@/models/valuation/Valuation';
import { Validator } from 'vee-validate';
import RegistrationOverlayComponent from './RegistrationOverlayComponent.vue';

@Component({
  components: {
  RegistrationOverlayComponent
  }
  })
export default class ManualEntryConfirmationStateComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: 'Make and Model' })
  public vehicleNameLabel!: string;

  @Prop({ default: 'Plate Year' })
  public vehiclePlateLabel!: string;

  @Prop({ default: false })
  public showDisabledState!: boolean;

  public get vehicleValuation(): Valuation {
    return this.$store.getters['vehicleValuationModule/vehicleValuation'];
  }

  public get vehicleName() {
    if (this.vehicleValuation) {
      if (this.vehicleValuation.vehicle) {
        return this.vehicleValuation.vehicle.name;
      }
    }

    return '';
  }

  public get vehiclePlate() {
    if (this.vehicleValuation) {
      if (this.vehicleValuation.vehicle) {
        return this.vehicleValuation.vehicle.plateYear;
      }
    }

    return '';
  }

  public clicked() {
    this.$emit('editManualEntryClick', true);
  }
}
</script>
